import { Fragment, useCallback, useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../../Context/GlobalContext";
import { useGlobalFunction } from "../../../Context/GlobalFunctionContext";
import { axiosInstance } from "../../../axios/axiosInstance";
import { useAuth } from "../../../Context/AuthContext";
import { isValidArray } from "../../../Layout/Common/common";
import { SearchResultContainer } from "./searchResultContainer";
import LoaderButton from "../../../Layout/Common/loaderButton";
import { search } from "@algolia/autocomplete-plugin-recent-searches";
import { ItemNotFoundInfo } from "../../QuickOrder/messageInfo/itemNotFoundInfo";
import { ResultSection } from "./resultSection";
import { set } from "lodash";

export const SearchProductItem = () => {
  const globalcontext = useContext(GlobalContext);
  const [suggestion, setSuggestion] = useState(null);
  const [productCode, setProductCode] = useState("");
  const [errorItem, setErrorItem] = useState(null);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [activeSuggestion, setActiveSuggestion] = useState(-1);
  const suggestionListRef = useRef(null);
  const quantityInputRef = useRef(null);
  const codeInputRef = useRef(null);
  const { refreshCartItem } = useGlobalFunction();
  const { userId, priceCode } = useAuth();
  const [searchResult, setSearchResult] = useState(null);
  const [searchNoResult, setSearchNoResult] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const searchResultCode = useRef("");

  const handleOnType = (e) => {
    if (e.target.value || e.target.value == "") {
      setProductCode(e.target.value);
      handleOnSearch(e.target.value);
    }
  };
  const handleOnSearch = (txt) => {
    if (txt == "") setSuggestion([]);
    else {
      axiosInstance
        .post("GetStaticData/ProductCodeAutoComplete", {
          sku: txt,
        })
        .then((response) => {
          if (response.data) {
            setSuggestion(response.data);
          }
        })
        .catch((error) => console.log(error.message));
    }
  };
  const autosuggestionKeyPress = (e) => {
    if (e.key == "ArrowDown" && activeSuggestion < suggestion.length - 1) {
      //setactiveSuggestion(parseInt(activeSuggestion) + 1);
      setActiveSuggestion((prev) => {
        const nextIndex = prev < suggestion.length - 1 ? prev + 1 : 0;
        scrollToActiveSuggestion(nextIndex);
        return nextIndex;
      });
    } else if (e.key == "ArrowUp" && activeSuggestion > 0) {
      setActiveSuggestion((prev) => {
        const nextIndex = prev > 0 ? prev - 1 : suggestion.length - 1;
        scrollToActiveSuggestion(nextIndex);
        return nextIndex;
      });
    } else if (e.key == "Enter") {
      if (activeSuggestion >= 0 && activeSuggestion < suggestion.length) {
        setProductCode(suggestion[activeSuggestion].code);
        setShowSuggestions(false);
        if (quantityInputRef.current) {
          quantityInputRef.current.focus();
        }
      }
    }
  };
  const scrollToActiveSuggestion = (index) => {
    const list = suggestionListRef.current;
    if (list) {
      const item = list.children[index + 2] || list.children[index + 1] || list.children[index];

      if (item) {
        item.scrollIntoView({ behavior: "smooth", block: "nearest" });
      }
    }
  };
  const handleOnPress = (e) => {
    if (e.key == "Enter") {
      handleSearchItem();
    }
  };

  const handleSearchItem = async () => {
    setIsSearching(true);
    setSearchResult(null);
    searchResultCode.current = productCode;
    let params = {
      userId: String(userId),
      priceCode: String(priceCode),
      sku: String(productCode).trim(),
    };
    try {
      let response = await axiosInstance.post("Ebook/SearchProductDetails", params);
      if (response && response.data) {
        setSearchNoResult(false);
        setSearchResult(response.data);
        setProductCode("");
      } else {
        setSearchNoResult(true);
      }
    } catch (error) {
      console.error("Search Product Error", error);
      setSearchResult(null);
      setSearchNoResult(true);
      setTimeout(() => {
        setSearchNoResult(false);
      }, 6000);
    }
    setIsSearching(false);
  };

  return (
    <Fragment>
      <div className="quickOrder-panel">
        <h3 className="quickOrder-title">Product Entry</h3>
        <div className="quickcart-search">
          <div className="quickOrder-container">
            <input
              ref={codeInputRef}
              type="text"
              onChange={handleOnType}
              value={productCode}
              autoComplete="off"
              data-required="true"
              className="form-control border border-1 py-1"
              id="quickOrderSearch"
              name="textbox"
              onFocus={() => setShowSuggestions(true)}
              onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
              onKeyDown={autosuggestionKeyPress}
              placeholder="Enter Order Code"
              onKeyPress={handleOnPress}
            />
            {showSuggestions && isValidArray(suggestion) && (
              <ul ref={suggestionListRef} className="autosuggest-suggestions">
                {suggestion.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => setProductCode(item.code)}
                    className={index == activeSuggestion ? "active" : ""}
                  >
                    {item.code}
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="button-effect product-button">
            <LoaderButton
              type="button"
              id="ebookSearchBtn"
              onClick={handleSearchItem}
              disabled={!productCode}
              className="btn btn-products btn-addcart addToCart"
              style={{
                marginBottom: 0,
                minWidth: "140px",
                height: "40px",
              }}
              isLoading={isSearching}
              loaderText="Searching..."
            >
              <span className="wes-search"></span>Search
            </LoaderButton>
          </div>
        </div>
        <ResultSection
          searchNoResult={searchNoResult}
          searchResult={searchResult}
          productCode={searchResultCode?.current}
        />
      </div>
    </Fragment>
  );
};
